import React, { useState } from "react";
import {
  Box,
  List,
  ListItemButton,
  ListItemText,
  ListItem,
  Popover,
  Typography,
} from "@mui/material";

import { useDispatch, useSelector } from "react-redux";
import { downloadCampaignData, fetchCampaign, fetchCampaignNames, fetchIndependentOwnerList, fetchOwnerNames, loadCampaigns, manageCampaignPaginationCookie } from "../../../api_calls/campaignRequests";
import {
  HtmlTooltip,
  HtmlTooltipDisabled,
  IconContainer,
  StyledStack,
  ThumbnailText,
  ThumbnailWithText,
} from "../../../components/commonComponents/StyledComponents/styled";
import ProgressBar from "../../../components/commonComponents/Progress/ProgressBar";
import {
  TrendingUp,
  HourglassTop,
  RoomService,
  Block,
  Visibility,
  Rule,

} from "@mui/icons-material";
import ActionButton, { DarkGreyButton, DarkGreyButtonForCampaignList, ReportAvailableButton } from "../../../components/commonComponents/Buttons/ActionButton";
import DisabledButton, { DisabledGreyButton } from "../../../components/commonComponents/Buttons/DisabledButton";
import {
  checkUserDetailsFromCookie,
  checkUserPermissions,
  checkUserRole,
  pageAccessAllowed,
} from "../../../api_calls/userManagement";
import { useNavigate } from "react-router-dom";
import AddNewMarketingActivity from "../ModalContent/AddMarketingActivity";
import AddNewCampaign from "../ModalContent/AddCampaign";
import { fetchRequiredDetailsBeforePopup } from "../../../api_calls/marketingActivities";
import MarketingActivitiesList from "./MarketingActivitiesList";
import { resetCampaignSheetData } from "../../../api_calls/campaignSheet";
import { requestAnalyticsReport } from "../../../api_calls/campaigns";
import { resetMarketingActivitiesData } from "../../../api_calls/marketingActivities";
import ReportSectionSettings from "../ModalContent/ReportSectionSettings";
import CampaignActions from "./campaignActions";
import NewProductModal from "../ModalContent/NewProductModal";
import ReportFilter from "../ModalContent/ReportFilter/ReportFilter";
import { fetchReportSettings, resetShareModalInfo } from "../../../api_calls/ReportSettings";
import { fetchWorkspaceSections } from "../../../api_calls/WorkspaceSections";
import { useListingTableController } from "../../../hooks/useListingTableController";
import ListingDataTable from "../../../components/commonComponents/TabularLists/ListingDataTable";
import { ListingCellCenter, ListingCellLeft } from "../../../components/commonComponents/TabularLists/styles";
import { resetListingCheckData } from "../../../api_calls/listingCheck";
import { setBatchLoadingStatus } from "../../../api_calls/requestConfig";

const CampaignList = () => {
  const campaignDetails = useSelector((state) => state.userSelections);

  const navigate = useNavigate();
  const userRole = checkUserRole();
  const downloadDataOptions = {
    "Impressions Data": 1,
    "Conversion Data - Stores": 3,
    "Conversion Data - Total": 2,
    "All Campaign Data": 4,
  };
  const ReportSettingOptions = ["Report Settings", "Data Sanity"];

  let listItems =
    typeof campaignDetails.campaign_list !== "undefined"
      ? campaignDetails.campaign_list.all_campaigns
      : [];
  let campaignListitems = listItems.length !== 0 ? listItems : [];
  // check if impression section is added
  const impressionAvailable = typeof userRole.user_role !== "undefined" && userRole.user_role.toLowerCase() === "brand" ? true : typeof campaignDetails.workspace_report_sections !== "undefined" && campaignDetails.workspace_report_sections !== null && campaignDetails.workspace_report_sections.length > 0 ? campaignDetails.workspace_report_sections.filter(sec => sec.type === "impression").length !== 0 : false;
  // check for performance sections added or not.
  const performanceAvailable = typeof userRole.user_role !== "undefined" && userRole.user_role.toLowerCase() === "brand" ? true : typeof campaignDetails.workspace_report_sections !== "undefined" && campaignDetails.workspace_report_sections !== null && campaignDetails.workspace_report_sections.length > 0 ? campaignDetails.workspace_report_sections.filter(sec => sec.type === "performance").length !== 0 : false;

  const checkRequestAccess = pageAccessAllowed(["campaign_reports_performance_can_request"], []);
  const checkEditAccess = pageAccessAllowed(["campaign_products_can_edit", "campaign_activities_can_edit", "campaign_list_can_edit", "campaign_can_share", "campaign_can_download", "campaign_reports_settings_can_view"], []);
  const isActionColumnAccessible = checkEditAccess;

  const checkUserDetails = checkUserDetailsFromCookie();
  const allowedAccessRights = checkUserPermissions();
  const permissionScope = allowedAccessRights.allowed_access;

  let userDetailObj = {};
  if (checkUserDetails.success === true) {
    userDetailObj = checkUserDetails.user_detail;
  }
  const [userInfo, setUserInfo] = useState(userDetailObj);
  const [popoverOpen, setPopoverOpen] = useState(null);
  const [options, setOptions] = useState([]);
  const [downloadOptions, setDownloadOptions] = useState(false);
  const [reportSettingsOptions, setReportSettingsOptions] = useState(false);
  const [listLoaded, setListLoaded] = useState(false);

  const [openModal, setOpenModal] = useState({
    products: false,
    activities: false,
    activity_list: false,
    data: false,
    edit_campaign: false,
    product_list: false,
    share_report: false,
  });
  const [campaignInfo, setCampaignInfo] = useState({});

  // to display the action items in popover when an icon is clicked.
  const handlePopoverOpen = (event, newOptions) => {
    setOptions(newOptions);
    setPopoverOpen(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setPopoverOpen(null);
    setDownloadOptions(false);
    setReportSettingsOptions(false);
  };

  // to handle the action when a specific icon is click from the action list.
  const handleOptionClick = (option) => {
    if (option === "Add new product") {
      setOpenModal({
        ...openModal,
        products: true,
      });
    }

    if (option === "Add new activity" || option === "List activities") {
      setBatchLoadingStatus(true);
      fetchRequiredDetailsBeforePopup(campaignInfo, navigate).then((info) => {
        setTimeout(() => {
          setOpenModal({
            ...openModal,
            activity_list: option === "List activities" ? true : false,
            activities: option === "Add new activity" ? true : false,
          });
          setBatchLoadingStatus(false);
        }, 1000);
      });
    }

    if (option === "List products") {
      setOpenModal({
        ...openModal,
        product_list: true,
      });
    }

    if (option === "Request Report") {
    }
    // download data option click
    if (Object.keys(downloadDataOptions).includes(option)) {
      downloadCampaignData(campaignInfo.campaign_name, downloadDataOptions[option]);
    }

    // report settings option click
    if (ReportSettingOptions.includes(option)) {
      if (option === "Data Sanity") {
        navigate("/check-campaigns/data-sanity/" + campaignInfo.campaign_id);
      } else {
        setBatchLoadingStatus(true);
        fetchReportSettings(campaignInfo.campaign_id).then(() => {
          setOpenModal((prevState) => ({ ...prevState, report_settings: true }));
          setCampaignInfo(campaignInfo);
        }).finally(() => {
          setBatchLoadingStatus(false);
        });
      }
    }
    handlePopoverClose();
  };

  // return markup for performance available button (so many conditions making it complex to define in jsx, so defining a separate function to return the button wherever needed.)
  const performanceButtonMarkup = (campaign) => {
    return (
      <>
        {/* ------- no action can be performed --------  */}
        {[0, 1].includes(campaign.campaign_status_code) && (
          <>
            {checkRequestAccess.success === true ? (
              <DisabledButton
                onClick={(e) => {
                  e.preventDefault();
                }}
                label={"Request"}
                icon={<RoomService />}
                ariaText={"report can not be requested for " + campaign.campaign_name}
                toolTipContent={
                  <List>
                    <ListItem>Please add analytics products before requesting the report</ListItem>
                  </List>
                }
              />
            ) : (
              <HtmlTooltip title={"No access"}>
                <IconContainer>
                  <Block sx={{ color: "#AF3241" }} />
                </IconContainer>
              </HtmlTooltip>
            )}
          </>
        )}
        {/* ------- request report button >> product data is available ------ */}
        {campaign.campaign_status_code === 3 && (
          <>
            {checkRequestAccess.success === true ? (
              <DarkGreyButton
                onClick={(e) => {
                  e.preventDefault();
                  // handlePopoverOpen(e, ["Request Report"]);
                  requestAnalyticsReport(campaign.campaign_id, campaign.campaign_name, campaign.retailer_company_id);
                }}
                label={"Request"}
                ariaText={"report can be requested for " + campaign.campaign_name}
                icon={<RoomService sx={{ color: "#fff" }} />}
                sx={{ mt: 0, mb: 0 }}
              />
            ) : (
              <HtmlTooltip title={"No access"}>
                <IconContainer>
                  <Block sx={{ color: "#AF3241" }} />
                </IconContainer>
              </HtmlTooltip>
            )}
          </>
        )}

        {/* ---- If data is processed and visualization also done >> show Report available button */}
        {performanceAvailable === true && campaign.campaign_status_code === 4 && (
          <ReportAvailableButton
            onClick={(e) => {
              e.preventDefault();
              navigate("/check-campaigns/campaign-analytics/" + campaign.campaign_id);
            }}
            label={"Available"}
            ariaText={"report available for " + campaign.campaign_name}
            icon={<TrendingUp sx={{ color: "#fff" }} />}
          />
        )}
        {/* ---- report available but sections aren't yet added ------- */}
        {performanceAvailable === false && campaign.campaign_status_code === 4 && (
          <DisabledGreyButton
            onClick={(e) => {
              e.preventDefault();
            }}
            label={"Requested"}
            ariaText={"report requested for " + campaign.campaign_name}
            icon={<HourglassTop sx={{ color: "#fff" }} />}
          // toolTipContent={
          //   <List>
          //     <ListItem>Your report is being prepared. This takes a maximum of one working day.</ListItem>
          //   </List>
          // }
          />
        )}
        {/* ------------ Report requested button -------- */}
        {campaign.campaign_status_code === 2 && (
          <DisabledGreyButton
            onClick={(e) => {
              e.preventDefault();
            }}
            label={"Requested"}
            ariaText={"report requested for " + campaign.campaign_name}
            icon={<HourglassTop sx={{ color: "#fff" }} />}
            toolTipContent={
              <List>
                <ListItem>Your report is being prepared. This takes a maximum of one working day.</ListItem>
              </List>
            }
          />
        )}
        {/* ---- completed campaigns, for which reporting not needed anymore ---- */}
        {campaign.campaign_status_code === 5 && (
          <Typography variant="body2">__</Typography>
        )}
      </>
    );
  };

  const initCampaignLookups = React.useCallback(async () => {
    setBatchLoadingStatus(true)
    await Promise.all([
      fetchCampaignNames(),
      fetchOwnerNames("list-campaigns"),
      fetchIndependentOwnerList(),
      fetchWorkspaceSections()
    ]).then(() => setBatchLoadingStatus(false));
    // scroll the page to the last position where user was before refreshing the page
    // scrollTableListings("campaign_pagination");
  }, []);

  const { pagination, onPageChange, onPageSizeChange } = useListingTableController({
    paginationReduxKey: "campaign_pagination",
    paginationCookieKey: "campaign_pagination",
    managePaginationCookie: manageCampaignPaginationCookie,
    loadPage: (pageNumber, pageSize) => loadCampaigns(pageNumber, pageSize).then(() => {
      setListLoaded(true);
    }),

    filtersReduxKey: "campaign_list_filters",
    filtersCookieKey: "campaign_list_filters",
    filterAppliedReduxKey: "campaign_list_filter_applied",

    onInit: initCampaignLookups,
    // onReset: resetCampaignsData,          // whatever your campaign reset fn is
    deletePaginationScope: "campaign",
    dataLoadedFlag: listLoaded
  });

  const columns = React.useMemo(() => {
    const cols = [
      {
        id: "name",
        header: "Name",
        cellClassName: "text-wrapper wrapLargeText",
        render: (campaign) => (
          <ListingCellLeft>
            <ThumbnailWithText>
              <ThumbnailText>{campaign.campaign_name}</ThumbnailText>
            </ThumbnailWithText>
          </ListingCellLeft>
        ),
      },
      {
        id: "progress",
        header: "Progress",
        headerAlign: "center",
        align: "center",
        render: (campaign) => (
          <ProgressBar
            startDate={campaign.campaign_start_date}
            endDate={campaign.campaign_end_date}
          />
        ),
      },
      {
        id: "owner",
        header: "Owner",
        headerAlign: "center",
        align: "center",
        render: (campaign) => (
          <ListingCellCenter>
            {campaign.retailer_company_name}
          </ListingCellCenter>
        ),
      },
    ];

    // Actions column (only if accessible)
    if (isActionColumnAccessible.success === true) {
      cols.push({
        id: "action",
        header: "Action",
        headerAlign: "center",
        align: "center",
        render: (campaign) => (
          <CampaignActions
            campaign={campaign}
            checkEditAccess={checkEditAccess}
            campaignDetails={campaignDetails}
            userInfo={userInfo}
            userRole={userRole}
            checkRequestAccess={checkRequestAccess}
            handlePopoverOpen={handlePopoverOpen}
            setCampaignInfo={setCampaignInfo}
            setOpenModal={setOpenModal}
            fetchCampaign={fetchCampaign}
            setDownloadOptions={setDownloadOptions}
            downloadDataOptions={downloadDataOptions}
            reportSettingsOptions={ReportSettingOptions}
            setReportSettingsOptions={setReportSettingsOptions}
          />
        ),
      });
    }

    // Impressions column
    if (permissionScope.campaign_reports_impression_can_view === true) {
      cols.push({
        id: "impressions",
        header: "Impressions",
        headerAlign: "center",
        align: "center",
        render: (campaign) => (
          <ListingCellCenter>
            {campaign.campaign_status !== "Scheduled" ? (
              <>
                {impressionAvailable === true && campaign.impression_report_status === 1 ? (
                  <ReportAvailableButton
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/check-campaigns/campaign-analytics/" + campaign.campaign_id);
                    }}
                    ariaText={"impressions available for " + campaign.campaign_name}
                    label={"Available"}
                    icon={<Visibility />}
                  />
                ) : (impressionAvailable === false || campaign.impression_report_status === 0) ? (
                  <DisabledButton
                    onClick={(e) => e.preventDefault()}
                    label={"Preparing"}
                    icon={<Rule />}
                    ariaText={"impressions awaited for " + campaign.campaign_name}
                    toolTipContent={
                      <List>
                        <ListItem>Preparing your impressions reports. Will be available soon.</ListItem>
                      </List>
                    }
                  />
                ) : campaign.impression_report_status === 2 ? (
                  <Typography variant="body2">__</Typography>
                ) : (
                  <Typography variant="body2">__</Typography>
                )}
              </>
            ) : (
              <Typography variant="body2">__</Typography>
            )}
          </ListingCellCenter>
        ),
      });
    }

    // Performance column
    if (permissionScope.campaign_reports_performance_can_view === true) {
      cols.push({
        id: "performance",
        header: "Performance",
        headerAlign: "center",
        align: "center",
        render: (campaign) => (
          <ListingCellCenter>
            {campaign.campaign_status !== "Scheduled" ? (
              <>
                {typeof userRole.user_role !== "undefined" &&
                  userRole.user_role.toLowerCase() === "brand" ? (
                  performanceButtonMarkup(campaign)
                ) : typeof userInfo.current_workspace !== "undefined" &&
                  (userInfo.current_workspace.name === campaign.retailer_company_name ||
                    userInfo.user_type === "cyreen") ? (
                  performanceButtonMarkup(campaign)
                ) : (
                  <Typography variant="body2">__</Typography>
                )}
              </>
            ) : (
              <Typography variant="body2">__</Typography>
            )}
          </ListingCellCenter>
        ),
      });
    }

    return cols;
  }, [campaignDetails]);


  return (<Box>
    <ListingDataTable
      columns={columns}
      rows={campaignListitems}
      rowKey={(c, idx) => `${c.campaign_id ?? idx}_campaign_row`}
      pagination={pagination}
      onPageChange={onPageChange}
      onPageSizeChange={onPageSizeChange}
      loading={typeof campaignDetails.campaign_list === "undefined" ? true : campaignDetails?.batchLoading}
    />

    {/* ---------- Load more button ----------- */}
    <Box height={20} />

    {/* ======== popover for the action items list =========== */}
    <Popover
      open={Boolean(popoverOpen)}
      anchorEl={popoverOpen}
      onClose={handlePopoverClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
    >
      <List>
        {options.map((option, index) => (
          <div key={index + "_popoverOptions"}>
            {/* Download data Options */}
            {downloadOptions === true && (
              // some buttons will be disabled if performance report is not yet generated
              <ListItemButton
                disabled={
                  ![4, 5].includes(campaignInfo.campaign_status_code) &&
                    ["Conversion Data - Stores", "Conversion Data - Total"].includes(option)
                    ? true
                    : false
                }
                onClick={() => handleOptionClick(option)}
              >
                <ListItemText secondary={option} />
              </ListItemButton>
            )
            }

            {/* Report Settings Options */}
            {reportSettingsOptions === true && (
              <HtmlTooltipDisabled title={permissionScope.campaign_reports_settings_can_view === false &&
                ["Report Settings"].includes(option) ? "Not Available" : ""}>
                {/* tooltip will only be shown for disabled options */}
                <span>
                  <ListItemButton
                    disabled={
                      permissionScope.campaign_reports_settings_can_view === false &&
                        ["Report Settings"].includes(option)
                        ? true
                        : false
                    }
                    onClick={() => handleOptionClick(option)}
                  >
                    <ListItemText secondary={option} />
                  </ListItemButton>
                </span>
              </HtmlTooltipDisabled>
            )}
          </div>
        ))}
      </List>
    </Popover>
    {/* -------- add products modal --------- */}
    {openModal.products === true && (
      <NewProductModal
        open={openModal.products}
        onClose={() => {
          setOpenModal({
            ...openModal,
            products: false,
          });
          /*
              reset the campaign sheet data (process of creating an adlevel will start all over again 
              if user comes back from the upload campaign sheet page and revisit the page for a 
              different campaign or even for same campaign.
            */
          resetCampaignSheetData();
          resetListingCheckData();
          loadCampaigns();
        }}
        size={"xl"}
        closeModal={() => {
          setOpenModal({
            ...openModal,
            products: false,
          });
          /*
              reset the campaign sheet data (process of creating an adlevel will start all over again 
              if user comes back from the upload campaign sheet page and revisit the page for a 
              different campaign or even for same campaign.
            */
          resetCampaignSheetData();
          resetListingCheckData();
          loadCampaigns();
        }}
        usedFor={"add"}
        campaignRecord={campaignInfo}
      />
    )}

    {/* ------- marketing activities list --------- */}
    {openModal.activity_list === true && (
      <MarketingActivitiesList
        open={openModal.activity_list}
        onClose={() => {
          setOpenModal({
            ...openModal,
            activity_list: false,
          });
          resetMarketingActivitiesData();
        }}
        size={"xl"}
        closeModal={() => {
          setOpenModal({
            ...openModal,
            activity_list: false,
          });
          resetMarketingActivitiesData();
        }}
        campaignRecord={campaignInfo}
      />
    )}
    {/* ----------- marketing activities popup --------- */}
    {openModal.activities === true && (
      <AddNewMarketingActivity
        open={openModal.activities}
        onClose={() => {
          setOpenModal({
            ...openModal,
            activities: false,
          });
          resetMarketingActivitiesData();
        }}
        size={"md"}
        closeModal={() => {
          setOpenModal({
            ...openModal,
            activities: false,
          });
          resetMarketingActivitiesData();
        }}
        usedFor={"add"}
        campaignRecord={campaignInfo}
      />
    )}
    {/* --------- edit campaign modal --------- */}
    {openModal.edit_campaign === true && (
      <AddNewCampaign
        open={openModal.edit_campaign}
        onClose={() => {
          setOpenModal({
            ...openModal,
            edit_campaign: false,
          });
          resetCampaignSheetData();
        }}
        size={"md"}
        closeModal={() => {
          setOpenModal({
            ...openModal,
            edit_campaign: false,
          });
          resetCampaignSheetData();
        }}
        usedFor={"update"}
        campaignRecord={campaignInfo}
      />
    )}
    {/* ------- share report modal --------- */}
    {openModal.share_report === true && (
      <ReportFilter
        open={openModal.share_report}
        onClose={() => {
          setOpenModal({
            ...openModal,
            share_report: false,
          });
          resetShareModalInfo();
        }}
        size={"md"}
        closeModal={() => {
          setOpenModal({
            ...openModal,
            share_report: false,
          });
          resetShareModalInfo();
        }}
        usedFor={"update"}
        campaignRecord={campaignInfo}
      />
    )}

    {/* ------- report section modal ---------- */}
    {openModal.report_settings === true && (
      <ReportSectionSettings
        open={openModal.report_settings}
        onClose={() => {
          setOpenModal({
            ...openModal,
            report_settings: false,
          });
        }}
        size={"md"}
        closeModal={() => {
          setOpenModal({
            ...openModal,
            report_settings: false,
          });
        }}
        usedFor={"update"}
        campaignRecord={campaignInfo}
      />
    )}
  </Box>);
};

export default CampaignList;
